export const HELPDESK_BASE_URL = 'https://help.zavior.app/en/articles';

export const HELPDESK_URLS = {

  //--------------------------------
  // SECURITY MENU
  //--------------------------------
  FRAMEWORK: `${HELPDESK_BASE_URL}/10123903-how-to-manage-framework-control-on-zavior`,
  CONTROL: `${HELPDESK_BASE_URL}/10123903-how-to-manage-framework-control-on-zavior`,
  POLICY_TEMPLATE: `${HELPDESK_BASE_URL}/10123903-how-to-manage-policy-templates-on-zavior`,
  POLICY_WIZARD: `${HELPDESK_BASE_URL}/10123903-how-to-manage-policy-wizards-on-zavior`,
  CONTROL_IMPLEMENTATION_TEMPLATE: `${HELPDESK_BASE_URL}/10123903-how-to-manage-control-implementation-templates-on-zavior`,
  FRAMEWORK_ORGANIZATION: `${HELPDESK_BASE_URL}/10123903-how-to-manage-framework-organizations-on-zavior`,
  RISKS: `${HELPDESK_BASE_URL}/10123903-how-to-manage-risks-on-zavior`,

  //--------------------------------
  // OPERATION MENU
  //--------------------------------
  POLICY_CENTER: `${HELPDESK_BASE_URL}/10078506-how-do-you-add-edit-view-delete-a-policy-on-zavior-platform`,
  POLICY: `${HELPDESK_BASE_URL}/10078544-viewing-approved-policies-on-zavior`,
  HARDWARE_ASSET: `${HELPDESK_BASE_URL}/10078552-how-do-you-add-edit-view-delete-a-hardware-asset-on-zavior-platform`,
  SOFTWARE_ASSET: `${HELPDESK_BASE_URL}/10123531-how-do-you-add-edit-view-delete-a-software-asset-on-zavior-platform`,
  VENDOR: `${HELPDESK_BASE_URL}/10121344-how-do-you-add-edit-view-delete-a-vendor-on-the-zavior-platform`,
  ACCOUNT: `${HELPDESK_BASE_URL}/10123662-how-do-you-add-edit-view-delete-an-account-on-zavior-platform`,
  DATA_INVENTORY: `${HELPDESK_BASE_URL}/10123823-how-do-you-add-edit-view-delete-data-inventory-on-zavior-platform`,
  RESOURCE_DEFAULTS: `${HELPDESK_BASE_URL}/10123823-how-to-manage-resource-default-fields-on-zavior`,
  
  //--------------------------------
  // REVIEW MENU
  //--------------------------------
  USER_REVIEW_SETUP: `${HELPDESK_BASE_URL}/10124001-user-review-setup-management`,
  
  //--------------------------------
  // FOCUS MODE
  //--------------------------------
  FOCUS_MODE_MANAGEMENT: `${HELPDESK_BASE_URL}/10124001-focus-mode-management`,
  
  //--------------------------------
  // SYSTEM MENU
  //--------------------------------
  MODEL_PERMISSIONS: `${HELPDESK_BASE_URL}/10124001-model-permissions-management`,
  AUDIT_STATUS: `${HELPDESK_BASE_URL}/10124001-audit-status-management`,
  AUDIT_STATUS: `${HELPDESK_BASE_URL}/10124001-audit-status-management`,

  //--------------------------------
  // AUDIT MENU
  //--------------------------------
  AUDIT_NOTES: `${HELPDESK_BASE_URL}/10124001-audit-notes-management`,
  AUDIT_DASHBOARD: `${HELPDESK_BASE_URL}/10124001-audit-dashboard`,
  
  //--------------------------------
  // ORGANIZATION MENU
  //--------------------------------
  /*
  ORGANIZATIONS: `${HELPDESK_BASE_URL}/10078552-how-do-you-add-edit-view-delete-a-hardware-asset-on-zavior-platform`,
  USERS: `${HELPDESK_BASE_URL}/10078552-how-do-you-add-edit-view-delete-a-hardware-asset-on-zavior-platform`,
  TRAINING: `${HELPDESK_BASE_URL}/10078552-how-do-you-add-edit-view-delete-a-hardware-asset-on-zavior-platform`,
  TRAINING_ATTENDANCE: `${HELPDESK_BASE_URL}/10078552-how-do-you-add-edit-view-delete-a-hardware-asset-on-zavior-platform`,
  GROUPS_ROLES: `${HELPDESK_BASE_URL}/10078552-how-do-you-add-edit-view-delete-a-hardware-asset-on-zavior-platform`,
  COUNTRY: `${HELPDESK_BASE_URL}/10078552-how-do-you-add-edit-view-delete-a-hardware-asset-on-zavior-platform`,
  PROJECTS: `${HELPDESK_BASE_URL}/10078552-how-do-you-add-edit-view-delete-a-hardware-asset-on-zavior-platform`,
  */

  //--------------------------------
  // REPORTS MENU
  //--------------------------------
  CYBER_HYGIENE_REPORT: `${HELPDESK_BASE_URL}/10123903-cyber-hygiene-report`,
  FRAMEWORK_COMPARISON: `${HELPDESK_BASE_URL}/10123903-framework-comparison`,
  TRUST_CENTER: `${HELPDESK_BASE_URL}/10123903-trust-center`,

  // ... other URLs
}; 